import script from "./ChartComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartComponent.vue?vue&type=script&setup=true&lang=js"

import "./ChartComponent.vue?vue&type=style&index=0&id=0a6bb99c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a6bb99c"]])

export default __exports__